import { Box, Flex, Heading, Text, VStack, List } from '@chakra-ui/react';

export const TiltControlStep: React.FC = () => {
  return (
    <Flex
      direction="column"
      align="center"
      minH="100vh"
      px={6}
      pt={16}
      pb={24}
      bg="white"
      overflowY="auto"
    >
      <VStack gap={5} maxW="500px" w="full">
        {/* Title */}
        <Heading
          fontSize={{ base: 'xl', md: '2xl' }}
          fontWeight="bold"
          color="green.500"
          textAlign="center"
        >
          Note on Tilt Control
        </Heading>

        {/* Main Rules */}
        <Box
          w="full"
          p={5}
          bg="gray.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="gray.200"
        >
          <VStack align="flex-start" gap={3}>
            <Flex align="center" gap={3}>
              <Flex
                align="center"
                justify="center"
                w="24px"
                h="24px"
                minW="24px"
                borderRadius="full"
                bg="red.500"
                color="white"
                fontSize="sm"
                fontWeight="bold"
              >
                ✕
              </Flex>
              <Text fontSize="sm" color="gray.700">
                <Text as="span" fontWeight="bold">
                  Do not
                </Text>{' '}
                press down on the camera by hand
              </Text>
            </Flex>
            <Flex align="center" gap={3}>
              <Flex
                align="center"
                justify="center"
                w="24px"
                h="24px"
                minW="24px"
                borderRadius="full"
                bg="green.500"
                color="white"
                fontSize="sm"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="sm" color="gray.700">
                Camera will ratchet forward to protect the motor
              </Text>
            </Flex>
            <Flex align="center" gap={3}>
              <Flex
                align="center"
                justify="center"
                w="24px"
                h="24px"
                minW="24px"
                borderRadius="full"
                bg="green.500"
                color="white"
                fontSize="sm"
                fontWeight="bold"
              >
                ✓
              </Flex>
              <Text fontSize="sm" color="gray.700">
                <Text as="span" fontWeight="bold">
                  Always
                </Text>{' '}
                tilt via the FrogBox Connect app
              </Text>
            </Flex>
          </VStack>
        </Box>

        {/* Image */}
        <Box w="full" maxW="280px" borderRadius="xl" overflow="hidden">
          <img
            src={`${import.meta.env.BASE_URL}images/manual-tilt.webp`}
            alt="Do not manually tilt the camera"
            style={{ width: '100%', height: 'auto' }}
          />
        </Box>

        {/* Warning Box */}
        <Box
          w="full"
          p={4}
          bg="yellow.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="yellow.400"
        >
          <Flex align="center" gap={2} mb={2}>
            <Flex
              align="center"
              justify="center"
              w="24px"
              h="24px"
              minW="24px"
              borderRadius="sm"
              bg="yellow.500"
              color="white"
              fontSize="xs"
              fontWeight="bold"
            >
              ⚠
            </Flex>
            <Text fontSize="sm" fontWeight="bold" color="gray.800">
              If the camera is moved by hand
            </Text>
          </Flex>
          <List.Root pl={8} gap={1}>
            <List.Item fontSize="sm" color="gray.700">
              Do not force the camera back into position
            </List.Item>
            <List.Item fontSize="sm" color="gray.700">
              Open the FrogBox Connect app and tap RESET or TILT ↑
            </List.Item>
          </List.Root>
        </Box>

        {/* Bottom Warning */}
        <Flex
          align="center"
          gap={3}
          w="full"
          p={4}
          bg="red.50"
          borderRadius="xl"
          border="1px solid"
          borderColor="red.300"
        >
          <Flex
            align="center"
            justify="center"
            w="24px"
            h="24px"
            minW="24px"
            borderRadius="sm"
            bg="red.500"
            color="white"
            fontSize="xs"
            fontWeight="bold"
          >
            ⚠
          </Flex>
          <Text fontSize="sm" color="gray.700">
            Repeated manual adjustment may cause{' '}
            <Text as="span" fontWeight="bold">
              irreversible damage
            </Text>
          </Text>
        </Flex>
      </VStack>
    </Flex>
  );
};
